// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"438729e3","977":"1b19ab30"}[chunkId] + ".chunk.js";
};